import { Head, router, usePage } from '@inertiajs/react';
import { useMemo, useState } from 'react';

import { RequestsTable } from '@/components/admin/requests/RequestsTable';
import { FilterTabs } from '@/components/ui/FilterTabs';
import { Select } from '@/components/ui/Select';
import { ALL_REQUEST_TYPES, getRequestTypeConfig } from '@/data/requestsConfig';
import type { SubmissionStatus } from '@/types/api/submission-status';

export interface RequestFile {
  filename: string;
  url: string;
}

export interface Request {
  id: number;
  referenceCode: string;
  type: string;
  payload: Record<string, unknown>;
  status: SubmissionStatus;
  submittedAt: string;
  handledBy: string | null;
  handledAt: string | null;
  files: RequestFile[];
}

const STATUS_TABS = [
  { label: 'Todos', value: 'all' },
  { label: 'Pendentes', value: 'pending' },
  { label: 'Resolvidos', value: 'handled' },
  { label: 'Arquivados', value: 'dismissed' },
];

const TYPE_OPTIONS = [
  { label: 'Todos os tipos', value: 'all' },
  ...ALL_REQUEST_TYPES.map((t) => ({ label: getRequestTypeConfig(t).label, value: t })),
];

interface RequestsPageProps {
  requests: Request[];
  [key: string]: unknown;
}

export default function Requests() {
  const { requests } = usePage<RequestsPageProps>().props;
  const [statusFilter, setStatusFilter] = useState('pending');
  const [typeFilter, setTypeFilter] = useState('all');

  const filtered = useMemo(() => {
    let result = requests;
    if (statusFilter !== 'all') {
      result = result.filter((r) => r.status === (statusFilter as SubmissionStatus));
    }
    if (typeFilter !== 'all') {
      result = result.filter((r) => r.type === typeFilter);
    }
    return result;
  }, [requests, statusFilter, typeFilter]);

  return (
    <>
      <Head title="Pedidos — Administração" />
      <div className="space-y-5">
        <h1 className="font-headline text-on-surface text-2xl font-bold">Pedidos</h1>

        <div className="flex flex-wrap items-center gap-3">
          <FilterTabs options={STATUS_TABS} value={statusFilter} onChange={setStatusFilter} />
          <Select options={TYPE_OPTIONS} value={typeFilter} onChange={setTypeFilter} />
        </div>

        <div className="surface-card overflow-hidden">
          <RequestsTable
            requests={filtered}
            onRowClick={(r) => router.visit(`/requests/${r.id}`)}
          />
        </div>
      </div>
    </>
  );
}
